import { Component, ViewEncapsulation, inject } from "@angular/core";
import { MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { TranslateModule } from "@ngx-translate/core";
import { SignRequestPath } from "@services/create-flow-state.service";

@Component({
  selector: "app-sign-request-path-dialog",
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, MatIconModule, TranslateModule],
  templateUrl: "./sign-request-path-dialog.component.html",
  styleUrl: "./sign-request-path-dialog.component.scss",
  encapsulation: ViewEncapsulation.None,
})
export class SignRequestPathDialogComponent {
  private _dialogRef = inject(MatDialogRef<SignRequestPathDialogComponent, SignRequestPath | undefined>);

  choose(path: SignRequestPath): void {
    this._dialogRef.close(path);
  }

  close(): void {
    this._dialogRef.close(undefined);
  }
}
